
import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "./../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import { format, parseISO } from 'date-fns';
import './Prvquartercomp.css';
import { useParams } from "react-router-dom";
import { useLocalStorage } from "./../../../utils/useLocalStorage";
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { Vortex } from 'react-loader-spinner'
import CompanyProfileOptions from "../../CompanyProfileOptions/CompanyProfileOptions";

function Prvquartercomp() {
    const [data, setData] = useState([]);
    const [co_code, setco_code] = useState([]);
    const [nameCom, setNameCom] = useState([]);
    const [dataGroup, setDataGroup] = useState([]);
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingshow, setloadingshow] = useState(false);
    const { getCompName } = useParams();
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;

    useEffect(() => {
        setloadingshow(true)
        // if (groupValue === "BSE") {
        const getUrl = BaseURL + "Prevquarter";
        fetch(`${getUrl}/${co_code}`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                setloadingshow(false)
            })
            .catch((error) => {
            });

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
            })
            .catch((error) => {
            });


    }, [co_code]);


    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    useEffect(() => {
        const getUrlchart = BaseURL + "getCo_Code";
        fetch(`${getUrlchart}/${getCompName}`)
            .then((response) => response.json())
            .then((data) => {
                setco_code(data.data[0]["co_code"]);
                setNameCom(data.data[0]["lname"]);
                //console.log(data)
            })
            .catch((error) => {
                //console.log("not found the api");
            });
    }, []);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/CompanyProfile/Get-Quotes">Company Profile</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Prev Quarter Comp</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='prvquarter-loser-sc'>
                            <div className='prvquarter-header'>
                                <h2><span>Prev Quarter Comp</span></h2>
                            </div>
                            <CompanyProfileOptions compOption="Prev Quarter Comp" />
                            <div>
                                <h4 className="text-center comp-name">{(nameCom != null) ? nameCom : ''}</h4>
                            </div>
                            <div className='prvquarter-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className="text-left">Particulars</th>
                                            <th className="text-right">Quarter Ended(Mar 2023)</th>
                                            <th className="text-right">Quarter Ended(Mar 2022)</th>
                                            <th className="text-right">Quarter Ended(% Var)</th>

                                        </tr>
                                    </thead>
                                    <tbody>

                                        {currentTableData && currentTableData.map(
                                            ({ CurrSales, PrevSales, SalesPerChange, CurrOtherIncome, PrevOtherIncome, OtherIncomePerChange, CurrPBIDT, PrevPBIDT,
                                                PBIDTPerChange, CurrInterest, PrevInterest, InterestPerChange, CurrPBDT, PrevPBDT, PBDTPerChange, CurrDepreciation, PrevDepreciation,
                                                DepreciationPerChange, CurrPBT, PrevPBT, PBTPerChange, CurrTax, PrevTax, TaxPerChange, CurrDeferredTax, PrevDeferredTax, DeferredTaxPerChange, CurrPAT, PATPerChange, prevPAT }) => (
                                                <>

                                                    <tr>
                                                        <td className='text-left'>Sales</td>
                                                        <td className='text-right'>{CurrSales.toFixed(2)}</td>
                                                        <td className='text-right'>{PrevSales.toFixed(2)}</td>
                                                        <td className='text-right'>{SalesPerChange.toFixed(2)}</td>
                                                    </tr>
                                                    <tr>

                                                        <td className='text-left'>Other Income</td>
                                                        <td className='text-right'>{CurrOtherIncome.toFixed(2)}</td>
                                                        <td className='text-right'>{PrevOtherIncome.toFixed(2)}</td>
                                                        <td className='text-right'>{OtherIncomePerChange.toFixed(2)}</td>
                                                    </tr>

                                                    <tr>
                                                        <td className='text-left'>PBIDT</td>
                                                        <td className='text-right'>{CurrPBIDT.toFixed(2)}</td>
                                                        <td className='text-right'>{PrevPBIDT.toFixed(2)}</td>
                                                        <td className='text-right'>{PBIDTPerChange.toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-left'>Interest</td>
                                                        <td className='text-right'>{CurrInterest.toFixed(2)}</td>
                                                        <td className='text-right'>{PrevInterest.toFixed(2)}</td>
                                                        <td className='text-right'>{InterestPerChange.toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-left'>PBDT</td>
                                                        <td className='text-right'>{CurrPBDT.toFixed(2)}</td>
                                                        <td className='text-right'>{PrevPBDT.toFixed(2)}</td>
                                                        <td className='text-right'>{PBDTPerChange.toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-left'> Depreciation</td>
                                                        <td className='text-right'>{CurrDepreciation.toFixed(2)}</td>
                                                        <td className='text-right'>{PrevDepreciation.toFixed(2)}</td>
                                                        <td className='text-right'>{DepreciationPerChange.toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-left'>PBT</td>
                                                        <td className='text-right'>{CurrPBT.toFixed(2)}</td>
                                                        <td className='text-right'>{PrevPBT.toFixed(2)}</td>
                                                        <td className='text-right'>{PBTPerChange.toFixed(2)}</td>

                                                    </tr>
                                                    <tr>
                                                        <td className='text-left'>Tax</td>
                                                        <td className='text-right'>{CurrTax.toFixed(2)}</td>
                                                        <td className='text-right'>{PrevTax.toFixed(2)}</td>
                                                        <td className='text-right'>{TaxPerChange.toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-left'>Deferred Tax</td>
                                                        <td className='text-right'>{CurrDeferredTax.toFixed(2)}</td>
                                                        <td className='text-right'>{PrevDeferredTax.toFixed(2)}</td>
                                                        <td className='text-right'>{DeferredTaxPerChange.toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-left'>PAT</td>
                                                        <td className='text-right'>{CurrPAT.toFixed(2)}</td>
                                                        <td className='text-right'>{prevPAT.toFixed(2)}</td>
                                                        <td className='text-right'>{PATPerChange.toFixed(2)}</td>
                                                    </tr>
                                                </>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>


            </Container>
        </>
    );
}

export default Prvquartercomp;
